module.exports = __webpack_public_path__ + "img/down-arrow.8a6c7ec3.svg";